export enum E_SUBSCRIPTION_TYPE {
  MAIN = 'main_subscription',
  MOBILE = 'general_subscription'
}

export const SUBSCRIPTION_TYPE = {
  MAIN: 'main_subscription',
  MOBILE: 'general_subscription'
}
